import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { Note } from "../../../Pages/UserVideoLessonDetail/ILessonsList";

type IVideoLesson = Note;

const initialState: IReduxState<IVideoLesson> = {
  data: {} as IVideoLesson,
  isLoading: false,
};

export const EditNoteVideoLessonsSlice = createSlice({
  name: "EditNoteVideoLessonsSlice",
  initialState,
  reducers: {
    // ✅ Do not store the payload (to avoid serializing File objects)
    EditNoteVideoLesson: (state, _action: PayloadAction<IVideoLesson>) => {
      state.isLoading = true;
    },

    successEditNoteVideoLessons: (
      state,
      action: PayloadAction<IVideoLesson>
    ) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureEditNoteVideoLessons: (state, action: PayloadAction<any>) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearEditNoteVideoLessonsResponse: (state) => {
      state.data = {} as IVideoLesson;
    },
  },
});

export const {
  EditNoteVideoLesson,
  successEditNoteVideoLessons,
  failureEditNoteVideoLessons,
  clearEditNoteVideoLessonsResponse,
} = EditNoteVideoLessonsSlice.actions;

export default EditNoteVideoLessonsSlice.reducer;
